export default {
  fields: {
    email: 'Dirección de correo electrónico',
    postcode: 'Código postal',
    title: 'Título',
    firstName: 'Nombre',
    lastName: 'Apellido',
    mobilePhone: 'Número de teléfono móvil',
    dateOfBirth: 'Fecha de nacimiento',
    birthday: 'Cumpleaños',
    fullAddress: 'Dirección completa',
    accept: {
      0: 'acepto el',
      1: 'Tengo más de 13 años y acepto el',
      2: 'Tengo más de 16 años y acepto el',
      3: 'Tengo más de 18 años y acepto el',
      4: 'Tengo más de 21 años y acepto el'
    }
  }
};